module.exports = __webpack_public_path__ + "img/inei.9df5ec0b.png";